import {Pipe, PipeTransform} from '@angular/core';

/**
 * Return the list of keys from an object
 */
@Pipe({
    name: 'keys'
})
export class KeysPipe implements PipeTransform {
    transform(value: Object): any {
        return Object.keys(value);
    }
}
